import React from "react";
import styled from "styled-components";
import { z } from "zod";
import { MediaPromoItem } from "./MediaItem";
import { SkinId } from "../../../skins/types";
import { MediaPromoBackdrop } from "./Backdrop";
import { Blade } from "../../../components/Blade";
import { MediaPromoContent } from "./MediaPromoContent";
import { riotProductSkin } from "../skins/riot-product";
import { lionSkin } from "../skins/project-l";
import { BladeContent } from "../../../components/BladeContent";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { MediaPromoBladeSchema } from "../../../schemas/blades/MediaPromo";
export var LayoutValues;
(function (LayoutValues) {
    LayoutValues["MediaFirstImpactLarge"] = "mediaFirstImpactLarge";
    LayoutValues["MediaLastImpactLarge"] = "mediaLastImpactLarge";
    LayoutValues["MediaFirstImpactSmall"] = "mediaFirstImpactSmall";
    LayoutValues["MediaLastImpactSmall"] = "mediaLastImpactSmall";
})(LayoutValues || (LayoutValues = {}));
export const MediaPromoBladeContractSchema = MediaPromoBladeSchema.extend({
    type: z.literal("mediaPromo"),
});
const _MediaPromoBlade = ({ backdrop, item, className, layout, ...bladeProps }) => {
    const validLayout = React.useMemo(() => {
        if (Object.values(LayoutValues).includes(layout || ""))
            return layout;
        return LayoutValues.MediaLastImpactSmall;
    }, [layout]);
    const isMediaFirstLayout = validLayout === LayoutValues.MediaFirstImpactLarge || validLayout === LayoutValues.MediaFirstImpactSmall;
    return (React.createElement(Blade, { "data-testid": "MediaPromoBlade", className: `${className} ${backdrop ? "backdrop-exist" : "backdrop-not-exist"} ${item?.media ? "layout-image" : "layout-no-image"}`, ...bladeProps },
        React.createElement(BladeContent, { width: "large", className: `blade-content ${item?.media ? "content-image" : "content-no-image"}` },
            backdrop && React.createElement(MediaPromoBackdrop, { ...backdrop }),
            React.createElement("div", { "data-testid": "mediapromo-main-container", className: `main-container ${validLayout} ${item?.media ? "w-image" : "wo-image"}` },
                React.createElement("div", { className: "left-container" }, isMediaFirstLayout ? (React.createElement(MediaPromoItem, { media: item?.media, youtubeLightbox: true })) : (React.createElement(MediaPromoContent, { ...item }))),
                React.createElement("div", { className: "right-container" }, isMediaFirstLayout ? (React.createElement(MediaPromoContent, { ...item })) : (React.createElement(MediaPromoItem, { media: item?.media, youtubeLightbox: true })))))));
};
export const MediaPromoBlade = styled(_MediaPromoBlade) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.RiotProductLion]: lionSkin,
})}
`;
//# sourceMappingURL=MediaPromoBlade.js.map